import React from 'react';
import Board from '../../components/Board/Board';

export default function BoardPage() {
  return <Board />;
}
